import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

type UseCompetitionTypeListQueryParams = Parameters<typeof SSF.api.competitionTypesList>[0];

export const keys = createQueryKeySet<UseCompetitionTypeListQueryParams>('competitions.types');

export function useCompetitionTypeListQuery(params?: UseCompetitionTypeListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.competitionTypesList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}
